export default "__VITE_ASSET__C4xaB_ZQ__"